<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    size="lg"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="Código del Curso *">
            <b-form-input
              v-model="form.codigo"
              placeholder="Ej: CS-101"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Créditos *">
            <b-form-input
              v-model.number="form.creditos"
              type="number"
              placeholder="Ej: 4"
              min="1"
              max="10"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Nombre del Curso *" class="mt-1">
        <b-form-input
          v-model="form.nombre"
          placeholder="Ej: Programación I"
          required
        />
      </b-form-group>

      <b-form-group label="Curso Prerequisito (Opcional)" class="mt-1">
        <b-form-select
          v-model="form.cursoPrerrequisitoId"
          :options="cursosOptions"
        >
          <template #first>
            <b-form-select-option :value="null">-- Sin Prerequisito --</b-form-select-option>
          </template>
        </b-form-select>
        <small class="text-muted">
          Seleccione el curso que debe aprobarse antes de tomar este curso
        </small>
      </b-form-group>

      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>

      <b-alert variant="info" show class="mt-2">
        <div class="alert-body">
          <feather-icon icon="InfoIcon" class="mr-50" />
          <span>Este curso podrá ser asignado a múltiples pensums según se necesite</span>
        </div>
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>
import { 
  BModal, 
  BForm, 
  BFormGroup, 
  BFormInput, 
  BFormSelect,
  BRow,
  BCol,
  BAlert,
  BFormSelectOption
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BAlert,
    BFormSelectOption,
  },
  props: {
    courseData: {
      type: Object,
      default: null,
    },
    cursos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalId: 'course-modal',
      form: {
        cursoId: null,
        codigo: '',
        nombre: '',
        creditos: null,
        cursoPrerrequisitoId: null,
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.cursoId ? 'Editar Curso' : 'Nuevo Curso'
    },
    cursosOptions() {
      // Filtrar el curso actual para que no pueda ser su propio prerequisito
      const cursosFiltrados = this.cursos.filter(c => c.cursoId !== this.form.cursoId)
      return cursosFiltrados.map(c => ({ 
        value: c.cursoId, 
        text: `${c.codigo} - ${c.nombre}` 
      }))
    },
  },
  watch: {
    courseData(newData) {
      if (newData) {
        this.form = { 
          cursoId: newData.cursoId,
          codigo: newData.codigo,
          nombre: newData.nombre,
          creditos: newData.creditos,
          cursoPrerrequisitoId: newData.cursoPrerrequisitoId || null,
          estado: newData.estado,
        }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        cursoId: null,
        codigo: '',
        nombre: '',
        creditos: null,
        cursoPrerrequisitoId: null,
        estado: true,
      }
    },
  },
}
</script>
